import React from 'react';
import './progress-ring.css';

/**
 * 로그인 직후 OAuthLoginOverlay와 동일한 원형 프로그레스 링
 * @param {number} size - 링 전체 크기(px)
 * @param {number} borderWidth - 링 테두리 두께(px)
 * @param {string} className - 추가 CSS 클래스
 * @param {React.ReactNode} children - 링 중앙 콘텐츠 (예: 로고)
 */
function ProgressRing({ size = 24, borderWidth, className = '', children = null }) {
  const resolvedBorder = borderWidth ?? Math.max(2, Math.round(size * 0.045));

  return (
    <div
      className={`progress-ring ${className}`.trim()}
      style={{
        width: size,
        height: size,
        '--progress-ring-border': `${resolvedBorder}px`,
      }}
      role="status"
      aria-label="Loading"
    >
      {children}
    </div>
  );
}

export default ProgressRing;
